// Mirrors Sale#expected_fees and config/initializers/globals.rb
const PERCENTAGE_TRESHOLD_PARIS = 400000;
const PERCENTAGE_TRESHOLD_REGIONS = 400000;
const PERCENTAGE_HIGH_TRESHOLD_PARIS = 1000000;
const PERCENTAGE_HIGH_TRESHOLD_REGIONS = 1000000;
const FEE_RATE = 0.029;
const FEE_RATE_COMP = 0.039;
const LOW_FEE_RATE = 0.025;
const LOW_FEE_RATE_COMP = 0.035;

// feesRegion is a string, noExclusivity is a boolean, price is an Integer
export function agencyFees(feesRegion, price, noExclusivity) {
  return feesRegion == 'Paris' ? parisFees(price, noExclusivity) : regionFees(price, noExclusivity);
}

export function parkingFees(noExclusivity) {
  return noExclusivity ? 4900 : 2900;
}

// Rate displayed instead of the amount when fees are a percentage, null otherwise
export function agencyFeesRateLabel(feesRegion, price) {
  const parisRegion = feesRegion == 'Paris';
  const highTreshold = parisRegion ? PERCENTAGE_HIGH_TRESHOLD_PARIS : PERCENTAGE_HIGH_TRESHOLD_REGIONS;
  const treshold = parisRegion ? PERCENTAGE_TRESHOLD_PARIS : PERCENTAGE_TRESHOLD_REGIONS;

  if (Number(price) >= highTreshold) { return formatRate(LOW_FEE_RATE) }
  else if (Number(price) >= treshold) { return formatRate(FEE_RATE) }
  else { return null }
}

function parisFees(price, noExclusivity) {
  if (price >= PERCENTAGE_HIGH_TRESHOLD_PARIS) { return truncatedFees(price, noExclusivity ? LOW_FEE_RATE_COMP : LOW_FEE_RATE) }
  else if (price >= PERCENTAGE_TRESHOLD_PARIS) { return truncatedFees(price, noExclusivity ? FEE_RATE_COMP : FEE_RATE) }
  else if (price < 100000) { return noExclusivity ? 9900 : 6900 }
  else if (price < 200000) { return noExclusivity ? 10900 : 7900 }
  else if (price < 300000) { return noExclusivity ? 12900 : 8900 }
  else { return noExclusivity ? 14900 : 10900 }
}

function regionFees(price, noExclusivity) {
  if (price >= PERCENTAGE_HIGH_TRESHOLD_REGIONS) { return truncatedFees(price, noExclusivity ? LOW_FEE_RATE_COMP : LOW_FEE_RATE) }
  else if (price >= PERCENTAGE_TRESHOLD_REGIONS) { return truncatedFees(price, noExclusivity ? FEE_RATE_COMP : FEE_RATE) }
  else if (price < 100000) { return noExclusivity ? 9900 : 6900 }
  else if (price < 200000) { return noExclusivity ? 10900 : 7900 }
  else if (price < 300000) { return noExclusivity ? 12900 : 8900 }
  else { return noExclusivity ? 14900 : 10900 }
}

// Mirrors Sale#truncated_fees
function truncatedFees(price, rate) {
  return Math.floor(Math.round(price * rate * 1000) / 1000);
}

function formatRate(rate) {
  return `${(Math.round(rate * 1000) / 10).toLocaleString('fr-FR')}%`;
}
